import htmlEntities from 'constants/htmlEntities';

const cleanHtmlEntities = (str) =>
  str.replace(/&[#a-z0-9]+;/gi, (entity) => htmlEntities[entity] || entity);

export default cleanHtmlEntities;
